import type { Messages } from './index'

/** Bahasa Malaysia — business register, more formal than the worker app. */
export const ms: Messages = {
  common: {
    cancel: 'Batal', confirm: 'Sahkan', close: 'Tutup', save: 'Simpan', done: 'Selesai',
    back: 'Kembali', next: 'Seterusnya', retry: 'Cuba lagi', loading: 'Memuatkan', today: 'Hari ini',
    tomorrow: 'Esok', hours: 'jam', perHour: '/jam', somethingWrong: 'Ada masalah berlaku.',
    all: 'Semua', none: 'Tiada',
  },
  nav: {
    dashboard: 'Papan Pemuka', shifts: 'Shift', timesheets: 'Jam Kerja',
    workers: 'Pekerja', billing: 'Pembayaran',
  },
  auth: {
    title: 'Pinch Crew untuk Perniagaan',
    subtitle: 'Siarkan shift, dan krew yang disahkan akan mengambilnya. Anda luluskan jam kerja; kami bayar pekerja.',
    email: 'E-mel kerja',
    password: 'Kata laluan',
    signIn: 'Log masuk',
    demoHint: 'Mod demo — mana-mana e-mel, kata laluan demo1234',
    invalid: 'E-mel atau kata laluan salah.',
    chooseOrg: 'Pilih syarikat',
    chooseOrgBody: 'Anda ada akses kepada lebih daripada satu. Anda boleh tukar bila-bila masa.',
  },
  dashboard: {
    title: 'Hari Ini',
    coverage: 'Perjawatan hari ini',
    coverageValue: '{filled} daripada {required} diisi',
    shiftsToday: 'Shift hari ini',
    notClockedIn: 'Belum daftar masuk',
    notClockedInHint: 'Pekerja yang sudah lepas waktu mula tetapi belum daftar masuk',
    pendingTimesheets: 'Menunggu kelulusan',
    balance: 'Baki tersedia',
    atRisk: 'Kekurangan pekerja dan bermula tidak lama lagi',
    atRiskBody: 'Shift ini bermula dalam 24 jam dan masih perlukan krew.',
    atRiskEmpty: 'Semua yang bermula tidak lama lagi sudah cukup pekerja',
    atRiskEmptyBody: 'Tiada apa-apa yang perlukan perhatian anda sekarang.',
    needsMore: 'perlu {n} lagi',
    viewShift: 'Lihat',
    allGood: 'Semua baik',
  },
  shifts: {
    title: 'Shift',
    post: 'Siarkan shift',
    empty: 'Belum ada shift',
    emptyBody: 'Siarkan shift pertama anda dan krew yang disahkan boleh mengambilnya.',
    filled: 'Cukup pekerja',
    open: 'Terbuka',
    completed: 'Selesai',
    cancelled: 'Dibatalkan',
    inProgress: 'Sedang berjalan',
    ofHeadcount: '{filled}/{headcount} diisi',
    roster: 'Senarai pekerja',
    noClaims: 'Belum ada sesiapa mengambil shift ini',
    noClaimsBody: 'Pekerja yang sepadan dengan peranan dan tier boleh melihatnya sekarang.',
    release: 'Keluarkan dari shift',
    releaseConfirm: 'Keluarkan {name} dari shift ini?',
    releaseBody: 'Kekosongan akan dibuka semula untuk pekerja lain. Dekat dengan waktu mula, ini boleh menyebabkan kekurangan.',
    cancelShift: 'Batalkan shift',
    cancelConfirm: 'Batalkan shift ini?',
    cancelBody: 'Tahanan pada baki anda akan dilepaskan. Sesiapa yang telah mengambilnya akan dimaklumkan.',
    cancelReason: 'Kenapa anda membatalkan?',
    clockedIn: 'Daftar masuk {time}',
    awaitingClockIn: 'Belum daftar masuk',
    rate: 'Nilai pekerja ini',
    rateBody: 'Penilaian mempengaruhi skor kebolehpercayaan dan siapa yang kami tunjukkan shift anda dahulu.',
    rateStars: 'Bintang',
    rateComment: 'Ada apa-apa nak tambah?',
    rateSubmit: 'Hantar penilaian',
  },
  post: {
    title: 'Siarkan shift',
    site: 'Cawangan mana?',
    skill: 'Peranan apa?',
    minTier: 'Tier minimum',
    minTierHint: 'Tier lebih tinggi kos lebih sejam tetapi perlukan kurang penyeliaan',
    date: 'Tarikh',
    startTime: 'Mula',
    endTime: 'Tamat',
    headcount: 'Berapa orang?',
    breakPaid: 'Rehat berbayar (minit)',
    dressCode: 'Apa yang perlu dipakai?',
    instructions: 'Di mana mereka lapor diri?',
    repeat: 'Ulang mingguan',
    repeatDays: 'Pada hari-hari ini',
    repeatWeeks: 'Untuk berapa minggu?',
    cost: 'Kos untuk ini',
    workerPay: 'Bayaran pekerja',
    platformFee: 'Yuran platform',
    processingFee: 'Pemprosesan bayaran',
    total: 'Jumlah',
    costNote: 'Dicaj semasa anda siarkan. Jam yang tidak digunakan akan dikreditkan semula ke baki anda.',
    insufficient: 'Baki tidak mencukupi',
    insufficientBody: 'Tambah {amount} untuk menyiarkan shift ini.',
    topUpNow: 'Tambah baki',
    publish: 'Siarkan dan bayar {amount}',
    publishing: 'Menyiarkan…',
    posted: 'Shift disiarkan',
    postedBody: 'Krew yang disahkan boleh melihatnya sekarang. Kami akan maklumkan apabila mereka mengambilnya.',
    postedMulti: '{n} shift disiarkan',
    errors: {
      invalid_times: 'Waktu tamat mesti selepas waktu mula.',
      invalid_headcount: 'Anda perlukan sekurang-kurangnya seorang pekerja.',
      insufficient_funds: 'Baki anda terlalu rendah untuk menyiarkan shift ini.',
    },
  },
  timesheets: {
    title: 'Jam Kerja',
    pending: 'Menunggu kelulusan',
    approved: 'Diluluskan',
    disputed: 'Dipertikai',
    settled: 'Dibayar',
    empty: 'Tiada apa-apa untuk diluluskan',
    emptyBody: 'Jam kerja muncul di sini selepas shift tamat.',
    approve: 'Luluskan',
    approveAll: 'Luluskan semua ({n})',
    approveAllConfirm: 'Luluskan {n} rekod jam kerja?',
    approveAllBody: 'Ini akan melepaskan bayaran kepada pekerja tersebut. Tindakan ini tidak boleh dibatalkan.',
    adjust: 'Laraskan jam',
    adjustTitle: 'Laraskan jam kerja',
    adjustBody: 'Guna ini hanya apabila rekod jam benar-benar salah. Pekerja akan dimaklumkan dan boleh membantah.',
    adjustHours: 'Jam untuk dibayar',
    adjustReason: 'Kenapa berubah?',
    scheduled: 'Dijadualkan',
    actual: 'Direkodkan',
    autoApproves: 'Lulus automatik {when}',
    autoNote: 'Apa-apa yang anda tidak tindak akan lulus automatik selepas {n} jam, supaya pekerja tidak tertunggu.',
    yourCost: 'Kos anda',
    workerGets: 'Pekerja terima',
  },
  workers: {
    title: 'Pekerja',
    all: 'Kumpulan anda',
    favourites: 'Kegemaran',
    blocked: 'Disekat',
    empty: 'Belum ada pekerja',
    emptyBody: 'Pekerja muncul di sini selepas mereka bekerja shift untuk anda.',
    shiftsWorked: '{n} shift di sini | {n} shift di sini',
    reliability: 'Kebolehpercayaan {n}',
    favourite: 'Jadikan kegemaran',
    unfavourite: 'Buang kegemaran',
    block: 'Sekat',
    unblock: 'Nyahsekat',
    blockConfirm: 'Sekat {name}?',
    blockBody: 'Mereka tidak akan melihat shift anda lagi. Ini tidak menjejaskan kedudukan mereka dengan majikan lain.',
    blockReason: 'Kenapa? (peribadi kepada anda)',
    favouriteHint: 'Kegemaran melihat shift anda dahulu.',
  },
  billing: {
    title: 'Pembayaran',
    balance: 'Baki',
    available: 'Tersedia',
    held: 'Ditahan untuk shift yang disiarkan',
    heldHint: 'Dikhaskan untuk shift yang telah anda siarkan. Dilepaskan jika shift dibatalkan.',
    topUp: 'Tambah baki',
    topUpTitle: 'Tambah baki anda',
    topUpBody: 'Shift akan menolak daripada baki ini semasa anda menyiarkannya.',
    amount: 'Jumlah',
    method: 'Bagaimana anda membayar?',
    topUpConfirm: 'Tambah {amount}',
    topUpDone: 'Baki telah ditambah',
    activity: 'Aktiviti',
    invoices: 'Invois',
    invoiceStatus: { draft: 'Draf', issued: 'Dikeluarkan', paid: 'Dibayar', overdue: 'Tertunggak' },
    due: 'Perlu dibayar {date}',
    entryKind: {
      topup: 'Tambah baki', booking_hold: 'Ditahan untuk shift', booking_release: 'Tahanan dilepaskan',
      settlement_debit: 'Shift diselesaikan', settlement_credit: 'Kredit dikembalikan',
      fee: 'Yuran platform', refund: 'Bayaran balik', withdrawal: 'Pengeluaran', adjustment: 'Pelarasan',
    },
    empty: 'Belum ada aktiviti',
  },
  org: { switch: 'Tukar syarikat', signOut: 'Log keluar', language: 'Bahasa' },
  siteQr: {
    title: 'Kod daftar masuk',
    site: 'Lokasi',
    alt: 'Kod QR daftar masuk Pinch Crew',
    hint: 'Pekerja mengimbas ini untuk daftar masuk dan keluar.',
    rotates: 'Bertukar dalam {n}s',
    refresh: 'Muat semula',
    openDisplay: 'Tunjuk kod daftar masuk',
  },
  signup: {
    title: 'Upah pekerja sambilan dengan Pinch Crew',
    subtitle: 'Siarkan syif, kami hantar krew yang telah disaring. Buka akaun syarikat anda dalam seminit.',
    company: 'Nama syarikat',
    contact: 'Nama anda',
    email: 'E-mel kerja',
    emailHint: 'Invois juga akan dihantar ke sini.',
    password: 'Kata laluan',
    passwordHint: 'Sekurang-kurangnya 8 aksara.',
    approvalNote: 'Kami menyemak setiap syarikat baharu sebelum syif pertama disiarkan, biasanya dalam satu hari bekerja. Anda boleh melihat-lihat sementara menunggu.',
    cta: 'Buka akaun',
    sendCode: 'Teruskan',
    verifyTitle: 'Semak e-mel anda',
    verifySubtitle: 'Kami hantar kod 6 digit ke {email}. Ia luput dalam 5 minit.',
    code: 'Kod pengesahan',
    codeHint: 'Enam digit dari e-mel yang baru kami hantar.',
    wrongEmail: 'Salah e-mel? Kembali',
    haveAccount: 'Sudah ada akaun?',
    haveNoAccount: 'Baru di Pinch Crew?',
    signIn: 'Log masuk',
    pendingTitle: 'Kami sedang menyemak syarikat anda',
    pendingBody: 'Anda boleh melihat-lihat sekarang. Penyiaran syif akan dibuka sebaik sahaja kami meluluskan, biasanya dalam satu hari bekerja.',
  },
}
